export default __webpack_public_path__ + "static/media/foto1.f9f86bb3.jpg";